var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    { attrs: { widget: _vm.widget } },
    [
      !_vm.isLoading
        ? _c("ValidationObserver", { ref: "form", attrs: { slim: "" } }, [
            _c(
              "form",
              {
                staticClass: "form-horizontal",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.updateSettings.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "container-fluid" }, [
                  _c(
                    "fieldset",
                    { staticClass: "form-group" },
                    [
                      _vm._l(_vm.settings, function(setting) {
                        return _c(
                          "div",
                          { key: setting.SettingName },
                          [
                            _c("Field", {
                              attrs: {
                                label: _vm.$t(
                                  _vm.getTranslationKey(
                                    setting.SettingName,
                                    "name"
                                  )
                                ),
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t(
                                  _vm.getTranslationKey(
                                    setting.SettingName,
                                    "tooltip"
                                  )
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "col-sm-2 col-md-1" },
                                          [
                                            _c("nzToggle", {
                                              model: {
                                                value: setting.SettingValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    setting,
                                                    "SettingValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "setting.SettingValue"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c("Field", {
                        attrs: {
                          label: _vm.$t("BLOCK_CALLS_SHAKEN_STIR"),
                          "has-tooltip": true,
                          "tooltip-text": _vm.$t("BLOCK_CALLS_SHAKEN_STIR_TT")
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "element",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3" },
                                    [
                                      _c("nzToggle", {
                                        on: {
                                          onToggle: _vm.onShakenStirToggle
                                        },
                                        model: {
                                          value: _vm.useShakenStirToBlockCalls,
                                          callback: function($$v) {
                                            _vm.useShakenStirToBlockCalls = $$v
                                          },
                                          expression:
                                            "useShakenStirToBlockCalls"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          2780330812
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "ValidationProvider",
                        {
                          ref: "useShakenStir",
                          attrs: {
                            name: "shakenStirOption",
                            rules: "required",
                            vid: "shakenStirOption"
                          }
                        },
                        [
                          _vm.useShakenStirToBlockCalls
                            ? _c(
                                "div",
                                [
                                  _c("Field", {
                                    attrs: {
                                      label: _vm.$t(
                                        "BLOCK_CALLS_SHAKEN_STIR_OPTIONS"
                                      ),
                                      "has-tooltip": true,
                                      "tooltip-text": _vm.$t(
                                        "BLOCK_CALLS_SHAKEN_STIR_OPTIONS_TT"
                                      )
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "element",
                                          fn: function() {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-3" },
                                                [
                                                  _c("MultipleToggle", {
                                                    attrs: {
                                                      value:
                                                        _vm.selectedShakenStirOption,
                                                      options:
                                                        _vm.shakenStirOptions
                                                    },
                                                    on: {
                                                      onToggle:
                                                        _vm.onSetShakenStirToggle
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 form-group__label-required"
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      906540912
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isBuyerTagsEnabled
                        ? _c(
                            "div",
                            [
                              _c("Field", {
                                attrs: {
                                  label: _vm.$t("BUYER_EXTRA_TAGS"),
                                  "has-tooltip": true,
                                  "tooltip-text": _vm.$t("BUYER_EXTRA_TAGS_TT")
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "element",
                                      fn: function() {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-3" },
                                            [
                                              _c("nzToggle", {
                                                on: {
                                                  onToggle:
                                                    _vm.onBuyerTagsSettingStatusChange
                                                },
                                                model: {
                                                  value:
                                                    _vm.buyerAccessToTagsEnabled,
                                                  callback: function($$v) {
                                                    _vm.buyerAccessToTagsEnabled = $$v
                                                  },
                                                  expression:
                                                    "buyerAccessToTagsEnabled"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  1938325136
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.buyerAccessToTagsEnabled
                        ? _c(
                            "div",
                            [
                              _c("Field", {
                                attrs: {
                                  label: _vm.$t("BUYER_EXTRA_TAGS_OPTIONS"),
                                  "has-tooltip": true,
                                  "tooltip-text": _vm.$t(
                                    "BUYER_EXTRA_TAGS_OPTIONS_TT"
                                  )
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "element",
                                      fn: function() {
                                        return [
                                          _c("CheckboxTagsTree", {
                                            attrs: {
                                              "available-tags":
                                                _vm.availableBuyerExtraTags,
                                              "selected-tags":
                                                _vm.buyerExtraTags,
                                              "show-selected": true,
                                              "default-classes": false
                                            },
                                            on: {
                                              "update:selectedTags":
                                                _vm.onSelectedTagsUpdate
                                            }
                                          })
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  2425307955
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("Field", {
                        attrs: {
                          label: _vm.$t("JORNAYA_SETTINGS"),
                          "has-tooltip": true,
                          "tooltip-text": _vm.$t("JORNAYA_SETTINGS_TT")
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "element",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3" },
                                    [
                                      _c("nzToggle", {
                                        on: {
                                          onToggle:
                                            _vm.onJornayaSettingStatusChange
                                        },
                                        model: {
                                          value: _vm.hasJornayaSettings,
                                          callback: function($$v) {
                                            _vm.hasJornayaSettings = $$v
                                          },
                                          expression: "hasJornayaSettings"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          191629109
                        )
                      }),
                      _vm._v(" "),
                      _vm.hasJornayaSettings
                        ? _c(
                            "div",
                            [
                              _c("JornayaSettings", {
                                attrs: {
                                  "jornaya-setting": _vm.jornayaSettings
                                },
                                on: {
                                  jornayaSettingsChange:
                                    _vm.onJornayaSettingsChange
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("Field", {
                        attrs: {
                          label: _vm.$t("TRUSTED_FORM_SETTINGS"),
                          "has-tooltip": true,
                          "tooltip-text": _vm.$t("TRUSTED_FORM_SETTINGS_TT")
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "element",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3" },
                                    [
                                      _c("nzToggle", {
                                        on: {
                                          onToggle:
                                            _vm.onTrustedFormSettingStatusChange
                                        },
                                        model: {
                                          value: _vm.hasTrustedFormSettings,
                                          callback: function($$v) {
                                            _vm.hasTrustedFormSettings = $$v
                                          },
                                          expression: "hasTrustedFormSettings"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3884630293
                        )
                      }),
                      _vm._v(" "),
                      _vm.hasTrustedFormSettings
                        ? _c(
                            "div",
                            [
                              _c("TrustedFormSettings", {
                                attrs: {
                                  "trusted-form-setting":
                                    _vm.trustedFormSettings
                                },
                                on: {
                                  trustedFormSettingsChange:
                                    _vm.onTrustedFormSettingsChange
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-sm-9 col-md-9 col-md-offset-3 col-sm-offset-3"
                      },
                      [
                        _c(
                          "PrimaryButton",
                          {
                            attrs: {
                              type: "submit",
                              "size-class": "btn-lg",
                              disabled: !_vm.isFormValid,
                              "show-loader-on-form": _vm.isUpdating
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("ACCOUNT_SETTINGS_PAGE_UPDATE_BUTTON")
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "ACCOUNT_SETTINGS_LOADING",
                    expression: "'ACCOUNT_SETTINGS_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }